import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.l3s_1 = new (CouplingImages())('overlayPng', 'graphqlSvg', 'logoSvg', 'noPartyImagePath', 'noPlayerImagePath', 'frodo', 'samwise', 'grayson', 'wayne', 'rosie', 'wendy', 'robPng', 'autumnPng');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CouplingImagesClass;
function CouplingImages() {
  if (CouplingImagesClass === VOID) {
    class $ {
      constructor(overlayPng, graphqlSvg, logoSvg, noPartyImagePath, noPlayerImagePath, frodo, samwise, grayson, wayne, rosie, wendy, robPng, autumnPng) {
        Companion_getInstance();
        this.y3r_1 = overlayPng;
        this.z3r_1 = graphqlSvg;
        this.a3s_1 = logoSvg;
        this.b3s_1 = noPartyImagePath;
        this.c3s_1 = noPlayerImagePath;
        this.d3s_1 = frodo;
        this.e3s_1 = samwise;
        this.f3s_1 = grayson;
        this.g3s_1 = wayne;
        this.h3s_1 = rosie;
        this.i3s_1 = wendy;
        this.j3s_1 = robPng;
        this.k3s_1 = autumnPng;
      }
      toString() {
        return 'CouplingImages(overlayPng=' + this.y3r_1 + ', graphqlSvg=' + this.z3r_1 + ', logoSvg=' + this.a3s_1 + ', noPartyImagePath=' + this.b3s_1 + ', noPlayerImagePath=' + this.c3s_1 + ', frodo=' + this.d3s_1 + ', samwise=' + this.e3s_1 + ', grayson=' + this.f3s_1 + ', wayne=' + this.g3s_1 + ', rosie=' + this.h3s_1 + ', wendy=' + this.i3s_1 + ', robPng=' + this.j3s_1 + ', autumnPng=' + this.k3s_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.y3r_1);
        result = imul(result, 31) + getStringHashCode(this.z3r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.a3s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.b3s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.c3s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.d3s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.e3s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.f3s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.g3s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.h3s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.i3s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j3s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.k3s_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CouplingImages()))
          return false;
        if (!(this.y3r_1 === other.y3r_1))
          return false;
        if (!(this.z3r_1 === other.z3r_1))
          return false;
        if (!(this.a3s_1 === other.a3s_1))
          return false;
        if (!(this.b3s_1 === other.b3s_1))
          return false;
        if (!(this.c3s_1 === other.c3s_1))
          return false;
        if (!(this.d3s_1 === other.d3s_1))
          return false;
        if (!(this.e3s_1 === other.e3s_1))
          return false;
        if (!(this.f3s_1 === other.f3s_1))
          return false;
        if (!(this.g3s_1 === other.g3s_1))
          return false;
        if (!(this.h3s_1 === other.h3s_1))
          return false;
        if (!(this.i3s_1 === other.i3s_1))
          return false;
        if (!(this.j3s_1 === other.j3s_1))
          return false;
        if (!(this.k3s_1 === other.k3s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CouplingImages');
    CouplingImagesClass = $;
  }
  return CouplingImagesClass;
}
//region block: exports
export {
  CouplingImages as CouplingImagesci5yi3b0zpw0,
  Companion_getInstance as Companion_getInstance1l5ym9otmdi2n,
};
//endregion

//# sourceMappingURL=CouplingImages.mjs.map
